<template>
  <q-inner-loading v-if="reportLoading || organizationLoading" showing color="secondary" />
  <property-compare
    v-else
    :comparable-addresses="comparable_addresses"
    :subject="subject"
    :report="report"
  />
</template>

<script lang="ts">
import { usePropertyReportStore } from '@/stores/propertyreport'
import type { PropertySearchResponse, RentSourceSubscriptionAttributes } from 'common'
import PropertyCompare from '@/components/PropertyReports/PropertyCompare.vue'
import { useUserStore } from '@/stores/user'
import { isLoaded } from '@/utils/loading'

export default {
  name: 'PropertyReportView',
  components: {
    PropertyCompare
  },
  props: {
    reportId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      reportLoading: false,
      subject: null as PropertySearchResponse | null,
      comparable_addresses: [] as PropertySearchResponse[],
      report: null as RentSourceSubscriptionAttributes | null
    }
  },
  computed: {
    organizationLoading() {
      return useUserStore().organizationLoading
    }
  },
  watch: {
    reportId() {
      usePropertyReportStore().cleanReportData()
      this.loadReport()
    }
  },
  beforeUnmount() {
    usePropertyReportStore().cleanReportData()
  },
  created() {
    this.loadReport()
  },
  methods: {
    loadReport() {
      this.reportLoading = true
      usePropertyReportStore()
        .getReport(parseInt(this.reportId))
        .then((response) => {
          if (isLoaded(response)) {
            this.report = response.data
            this.subject = response.data.subject
            this.comparable_addresses = response.data.comparable_addresses
            useUserStore().addRecentReport({ id: this.reportId, name: response.data.name })
          } else {
            console.error('Report not found', this.reportId, response)
            this.$router.push({ name: 'Dashboard' })
          }
        })
        .catch((error) => {
          console.error('Report not found', this.reportId, error)
          this.$router.push({ name: 'Dashboard' })
        })
        .finally(() => {
          this.reportLoading = false
        })
    }
  }
}
</script>
<style scoped>
.property-report-dashboard {
  margin: auto;
}
</style>
